import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get the absolute URL for a path based on environment
 * - Handles development environment (localhost)
 * - Uses NEXT_PUBLIC_SITE_URL if available
 * - Falls back to VERCEL_BRANCH_URL for branch preview deployments
 * - Falls back to VERCEL_URL for specific deployment previews
 * - Uses production domain as final fallback
 */
export function getAbsoluteUrl(path: string = ""): string {
  // Remove any leading slash from the path for consistent joining
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  
  // Check if we're in development environment
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  // Get the local development URL if in development mode
  if (isDevelopment) {
    // Default development port (can be overridden by PORT env var)
    const port = process.env.PORT || 3000;
    // Use localhost with the current port
    return `http://localhost:${port}${cleanPath ? `/${cleanPath}` : ''}`;
  }
  
  // Use canonical domain for production, Vercel URL for previews
  const baseUrl = process.env.VERCEL_ENV === 'production' 
    ? 'https://manoellemos.com'
    : `https://${process.env.VERCEL_URL}`;
  
  // Join the base URL with the path
  return `${baseUrl}${cleanPath ? `/${cleanPath}` : ''}`;
}
